import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { XCircle } from 'lucide-react';
export function WhatWeAreNotSection() {
  return <SectionWrapper background="white" className="border-t border-slate-100" data-id="element-261">
      <div className="max-w-5xl mx-auto" data-id="element-262">
        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-6 text-center" data-id="element-263">
          Our Editorial Standards
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-264">
          {[{
          title: 'No User Reviews',
          desc: 'We rely on expert analysis, not unverified opinions.'
        }, {
          title: 'No Pay-to-Play',
          desc: 'Rankings cannot be bought. Not by clients, not by anyone.'
        }, {
          title: 'No Hidden Conflicts',
          desc: 'Business relationships are disclosed on every relevant guide.'
        }, {
          title: 'Editorial Independence',
          desc: 'Service revenue never influences our evaluations or methodology.'
        }].map((item, i) => <div key={i} className="flex items-start gap-3 p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-265">
              <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-266" />
              <div data-id="element-267">
                <h4 className="font-bold text-slate-900 text-sm" data-id="element-268">
                  {item.title}
                </h4>
                <p className="text-xs text-slate-500 mt-1" data-id="element-269">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}